import styled from 'styled-components';
import { StyledInputQuantityProps } from './InputQuantity.types';

export const StyledInputQuantity = styled.span<StyledInputQuantityProps>`
  display: flex;
  flex-direction: ${(props) => (props.isSelect ? 'row' : 'column')};
  align-items: center;
  justify-content: center;

  .input-quantity__select {
    &:disabled {
      appearance: none;
    }
  }
  .input-quantity__action {
    display: flex;
    align-items: center;
  }

  .input-quantity__action__button-minus,
  .input-quantity__action__button-plus {
    border-style: none;
    background-color: transparent;
    cursor: pointer;
  }

  .input-quantity__action__input {
    text-align: center;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0;
    }
  }

  ${(props) => props.customStyle}
`;
